import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-2 text-sm text-muted-foreground"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_4 = {
  key: 1,
  class: "support-items"
}
const _hoisted_5 = { class: "mark" }
const _hoisted_6 = { class: "support-product" }
const _hoisted_7 = { class: "support-date num" }

import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { BookOpen, MapPin, CircleAlert } from '@lucide/vue';

import { computed } from 'vue';
import moment from 'moment';

interface Props {
  property: Property;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyCard',
  props: {
    property: {}
  },
  setup(__props: any) {

const props = __props;

const activeSupport = computed(() => {
  return props.property?.supporters?.filter((s) => s.support_till || s.support_suspended) || [];
});

const hasActiveSupport = computed(() => {
  return activeSupport.value.length > 0;
});

function isOverdueSupport(date: any): boolean {
  return moment(date, 'YYYY-MM-DD').diff(Date.now()) < 0;
}

function formatDate(date: string): string {
  return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.property)
    ? (_openBlock(), _createBlock(_unref(Card), {
        key: 0,
        class: "property-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardHeader), { class: "property-card-header" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: { name: 'property-detail', params: { id: __props.property.id } },
                class: "property-name"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.property.name), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              (__props.property.wiki_hyperlink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: __props.property.wiki_hyperlink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "icon-link wiki-btn",
                    "aria-label": "Открыть Wiki",
                    title: "Wiki"
                  }, [
                    _createVNode(_unref(BookOpen), { size: 16 })
                  ], 8, _hoisted_1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(CardContent), { class: "space-y-3" }, {
            default: _withCtx(() => [
              (__props.property.city)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_unref(MapPin), {
                      size: 14,
                      class: "shrink-0"
                    }),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(__props.property.city.name) + " ", 1),
                      (__props.property.city.utc_offset !== null && __props.property.city.utc_offset !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (UTC" + _toDisplayString(__props.property.city.utc_offset >= 0 ? '+' : '') + _toDisplayString(__props.property.city.utc_offset) + ") ", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (hasActiveSupport.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeSupport.value, (s) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: s.product,
                        class: _normalizeClass(["support-item", {
            'support-overdue': isOverdueSupport(s.support_till),
            'support-suspended': s.support_suspended,
          }])
                      }, [
                        _createElementVNode("span", _hoisted_5, [
                          (isOverdueSupport(s.support_till) || s.support_suspended)
                            ? (_openBlock(), _createBlock(_unref(CircleAlert), {
                                key: 0,
                                size: 14,
                                title: s.support_suspended ? 'Поддержка приостановлена' : 'Поддержка просрочена'
                              }, null, 8, ["title"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(s.product), 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(formatDate(s.support_till)), 1)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})